import calculateScheduledDistribution from './calculateScheduledDistribution';

const memo = new Map();

// "Balance" column for "Paid" invoices should display the cumulative sum of "Actual Collected" ('impound_collected') column minus "Distributions" (calculated by 'calculateScheduledDistribution' function). For example, if invoice 1 actual collected is 100, invoice 2 actual collected is 100, and invoice 2 has distributions of 50, the balance should be 100 for invoice 1 and 150 to invoice.

//   !!! impound_collected for all display and calculation purposes was replaced with _paid_impounds.amount_paid
const calculateBalance = ({ row, sortedInvoices, bills }) => {
  if (!sortedInvoices) {
    return '-';
  }

  if (!row) {
    return 0;
  }

  if (memo.has(row.id)) {
    return memo.get(row.id);
  }

  const isPaid = row.status === 'paid';

  const currentInvoiceIndex = sortedInvoices?.findIndex(
    (inv) => inv.id === row.id
  );

  let distribution = calculateScheduledDistribution({ row, bills }).sum;
  if (distribution === '-') {
    distribution = 0;
  } else {
    distribution = distribution.replace('$', '').replace(',', '');
    distribution = parseFloat(distribution);
  }

  const currentInvoiceBalance =
    (isPaid
      ? row._paid_impounds?.amount_paid ?? 0
      : row?._impounds_total?.invoice_total ?? 0) +
    (currentInvoiceIndex !== 0
      ? calculateBalance({
          row: sortedInvoices[currentInvoiceIndex - 1],
          sortedInvoices,
          bills,
        })
      : 0) -
    distribution;

  // round it to 2 decimals
  const roundedBalance = parseFloat(currentInvoiceBalance.toFixed(2));

  memo.set(row.id, roundedBalance);

  /* console.log(
    `${row.sequence}:`,
    isPaid
      ? row._paid_impounds?.amount_paid ?? 0
      : row?._impounds_total?.invoice_total ?? 0,
    ' + ',
    calculateBalance({
      row: sortedInvoices[currentInvoiceIndex - 1],
      sortedInvoices,
      bills,
    }),
    ' - ',
    distribution,
    ' = ',
    roundedBalance
  ); */

  // console.log(`${row.sequence}:`, row);

  return roundedBalance;
};

export const clearBalanceMemo = () => memo.clear();

export default calculateBalance;
